import React from "react";
import calendar from "../../../assets/calendar.png";
import avantiIcon from "../../../assets/avantiicon.png";
import { CalendarContainer, CalendarImageWrapper, CalendarImg, CalendarAvantiIconImg } from "../styles";

const CalendarContent = () => {
    return (
        <CalendarContainer>
            <CalendarImageWrapper>
                <CalendarImg src={calendar} alt="calendar" />
                <CalendarAvantiIconImg src={avantiIcon} alt="avanti-icon" />
            </CalendarImageWrapper>
        </CalendarContainer>
    )
}
export default CalendarContent;